import React from "react";
import {
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";

import TopUpOrCashOut from "./TopUpOrCashOut/TopUpOrCashOut";

import "./CashPage.sass";

export default function CashPage({ currentUser }) {
  const { isExact, url } = useRouteMatch();
  const { pathname } = useLocation();
  const topUpPath = `${url}/top-up`;
  const cashOutPath = `${url}/cash-out`;

  return (
    <Row className="CashPage">
      {isExact && <Redirect to={topUpPath} />}

      <Col className="h-100 CashPage__col" xs={12}>
        <Card className="CashPage__card h-100 overflow-auto border-0">
          <Card.Body className="CashPage__body">
            <header className="CashPage__header">
              <h1 className="CashPage__title">
                {pathname === topUpPath && "Top up"}
                {pathname === cashOutPath && "Cash out"}
              </h1>
              <Nav
                className="CashPage__pill-nav justify-content-center flex-wrap"
                variant="pills"
              >
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    active={pathname === topUpPath}
                    to={topUpPath}
                  >
                    Top up
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    active={pathname === cashOutPath}
                    to={cashOutPath}
                  >
                    Cash out
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </header>

            <div className="CashPage__main">
              <Switch>
                <Route exact path={topUpPath}>
                  <TopUpOrCashOut type="topUp" currentUser={currentUser} />
                </Route>

                <Route exact path={cashOutPath}>
                  <TopUpOrCashOut type="cashOut" currentUser={currentUser} />
                </Route>
              </Switch>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
